import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type NotificationMessageErrorStyles = {
  container: CSSProperties;
  card: CSSProperties;
  header: CSSProperties;
  iconCircle: CSSProperties;
  image: CSSProperties;
  title: CSSProperties;
  text: CSSProperties;
  actions: CSSProperties;
  primaryButton: CSSProperties;
  secondaryButton: CSSProperties;
};

const styles: NotificationMessageErrorStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    minHeight: 'auto',
    paddingTop: '16px'
  },
  card: {
    backgroundColor: AppColors.VA.NEUTRALS.WHITE,
    borderRadius: '8px',
    padding: '32px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 'clamp(280px, 90vw, 560px)'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '12px'
  },
  iconCircle: {
    color: AppColors.VA.ERROR._50_,
    backgroundColor: AppColors.VA.ERROR._10_,
    borderRadius: '50%',
    width: 'clamp(64px, 10vw, 96px)',
    height: 'clamp(64px, 10vw, 96px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    lineHeight: '1',
    flexShrink: '0'
  },
  image: {
    width: 'clamp(28px, 5vw, 40px)',
    height: 'clamp(28px, 5vw, 40px)',
    objectFit: 'contain'
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: AppColors.VA.NEUTRALS._90_,
    lineHeight: '24px',
    margin: 0,
    textAlign: 'center'
  },
  text: {
    fontSize: '14px',
    color: AppColors.VA.NEUTRALS._90_,
    fontWeight: 400,
    lineHeight: '22px',
    marginTop: '4px',
    textAlign: 'center'
  },
  actions: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    width: '100%',
    marginTop: '16px',
    flexWrap: 'wrap'
  },
  primaryButton: {
    backgroundColor: AppColors.VA.PRIMARY._50_,
    color: AppColors.VA.NEUTRALS.WHITE,
    borderRadius: '8.49px',
    fontWeight: 400,
    fontSize: '14px',
    height: '48px',
    lineHeight: '22px',
    width: 'clamp(140px, 40vw, 200px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  secondaryButton: {
    borderColor: AppColors.VA.PRIMARY._50_,
    color: AppColors.VA.PRIMARY._50_,
    borderRadius: '8.49px',
    fontWeight: 400,
    fontSize: '14px',
    height: '48px',
    lineHeight: '22px',
    width: 'clamp(140px, 40vw, 200px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  }
};

export default styles;
